import React from 'react'
import { View, Text, TouchableOpacity, Image, StatusBar } from 'react-native'
import styles from './ModalDownloadCourseStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'

interface ModalNextCourseOfflineNotDownloadedProps {
    image: any
    title: string
    description: string
    button: boolean
    buttonDelete: boolean
    buttonCancel: boolean
    closeBottomSheet: (arg0: boolean) => void
    courseDeleted: (arg0: boolean) => void
}

export const ModalNextCourseOfflineNotDownloaded = ({
    image,
    title,
    description,
    button,
    buttonDelete,
    buttonCancel,
    closeBottomSheet,
    courseDeleted,
}: ModalNextCourseOfflineNotDownloadedProps) => {
    const { languageFile } = getLanguage()

    return (
        <View>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}

            <View style={styles.container}>
                <Image style={styles.image} source={image} />
                <Text style={styles.title}>{title}</Text>

                <Text style={styles.description}>{description}</Text>
            </View>
            {!button && !buttonCancel && <View style={{ height: 24 }}></View>}
            {button && <View style={!buttonCancel ? styles.spacer : styles.spacerBis}></View>}
            {buttonDelete && <View style={!buttonCancel ? styles.spacer : styles.spacerBis}></View>}
            {button && (
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => (buttonCancel ? courseDeleted(true) : closeBottomSheet(true))} style={styles.mainButton}>
                        <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                    </TouchableOpacity>
                    {buttonCancel && (
                        <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderButton}>
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}
            {buttonDelete && (
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => (buttonCancel ? courseDeleted(true) : closeBottomSheet(true))} style={styles.deleteButton}>
                        <Text style={styles.mainButtonText}>Eliminar</Text>
                    </TouchableOpacity>
                    {buttonCancel && (
                        <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderButton}>
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}
        </View>
    )
}
